import {
  IMG_6AZWds73eDs6cYUcsNTOb4,
  IMG_6CiupNcbwZWioKOCt3PIAA,
  IMG_7rTc0nb3AVq5NG9WLUcG5I
} from '@ecomm/contentful-media'
import type { AppWidgetTab, ExpertsReviewsProps } from '@ecomm/scout'
import type { Locale } from '@ecomm/utils'

import type { LanderBelowTheFoldSchema } from '../components/BelowTheFold/schema'

const findByContentfulId = (
  contentfulId: string,
  images: LanderBelowTheFoldSchema['expertReviewsAssets']['items']
) => {
  /* istanbul ignore next */
  return images.find(element => element.sys.id === contentfulId)
}

export const getContentfulImageId = (key: string, locale: Locale) => {
  const isUSData = locale === 'en-US'
  const imageData: Record<string, string> = {
    Cameras: isUSData ? '4WmsMErxVXBFHEjlFnRcD1' : 'ZYB8WxMtOe454lse5FG2D',
    Controls: isUSData ? '4Z794ao9hfY826K8Tt4FXz' : '6LT6dvk157aAfFdKyeG2Kf',
    Alarms: '4ju8RHivPNhZIeWF0WJ75X',
    Doorbell: isUSData ? '77eZKHHyg4KdFR2T2WhH90' : '38iheGuzSVg8kPQ1aokAnw',
    'us-news': '6uVhRdfLw8y6L3x78SiCuM',
    cnet: '5qECjj8vYgV5ThjxYhWtaw',
    newsweek: '3aPO8RfSjwoD7HLMeS8pQE',
    Alerts: '50wlqz44dQwAzOoxzmPO90', // UK only
    which: '7eH4KhA049wM5ZTOOmWyWd', // UK only
    t3: '5X5OsfxAW6Fc2Zj3HZDlHC', // UK only
    nhw: '2zLbCUSDMAqzV7LqBPgxzE', // UK only
    granddesigns: '3Yk2CSFz84KprPq2t0oyU8' // UK only
  }
  return imageData[key]
}

export const getExpertReviews = (
  images: LanderBelowTheFoldSchema['expertReviewsAssets']['items'],
  locale: Locale,
  reviews: ExpertsReviewsProps['reviews']
) => {
  const reviewsWithImages = reviews.map(review => {
    const imageCTFLId = getContentfulImageId(review.key, locale) || ''
    return {
      ...review,
      image: findByContentfulId(imageCTFLId, images)
    }
  })

  return reviewsWithImages.filter(review => !!review.image)
}

export const getAppWidgetData = (
  images: LanderBelowTheFoldSchema['expertReviewsAssets']['items'],
  locale: Locale,
  tabs: readonly AppWidgetTab[]
) =>
  tabs.map(tab => {
    const imageCTFLId = getContentfulImageId(tab.tab, locale) || ''
    return {
      ...tab,
      image: findByContentfulId(imageCTFLId, images)
    }
  })

export const appRatingImages = {
  appStoreLogo: IMG_6AZWds73eDs6cYUcsNTOb4,
  playStoreLogo: IMG_6CiupNcbwZWioKOCt3PIAA,
  simplisafeIcon: IMG_7rTc0nb3AVq5NG9WLUcG5I
}
